import {
  formatBudgetReferenceLine,
  sceneDimensionsToCatalog,
  type CatalogDimensions,
} from '@utils/dimensions/catalogDimensions'

type BudgetItemLike = {
  id?: unknown
  type?: string
  universal?: boolean
  referencia?: string
  catalogID?: string | number
  width?: unknown
  height?: unknown
  thickness?: unknown
}

export type BudgetPiece = {
  id: string
  referencia: string
  dimensions: CatalogDimensions
}

/**
 * Referencia limpia para presupuesto:
 * - KUBE: "K1RB 070 040 051" → "K1RB" (las cotas van aparte en el sufijo).
 * - Resto: quita sufijo numérico tipo "-1".
 */
export function normalizeBudgetReference(item: BudgetItemLike): string {
  const rawReference = String(item.referencia || item.catalogID || '-').trim()
  if (!rawReference) return '-'
  if (item.type !== 'linkedItem') return rawReference

  // Códigos KUBE: unidad + grupos de medidas en catálogo (2 o 3).
  if (/^K\d+[A-Z]*/i.test(rawReference)) {
    return rawReference.replace(/(?:\s+\d+)+$/i, '').trim() || rawReference
  }

  return rawReference.replace(/-\d+$/i, '')
}

export function buildBudgetPieceFromItem(item: BudgetItemLike): BudgetPiece {
  return {
    id: String(item.id || ''),
    referencia: normalizeBudgetReference(item),
    dimensions: sceneDimensionsToCatalog({
      width: item.width,
      height: item.height,
      thickness: item.thickness,
    }),
  }
}

export function buildBudgetPiecesFromItems(items: Iterable<BudgetItemLike>): BudgetPiece[] {
  return Array.from(items)
    .filter((item) => item.type === 'linkedItem' && item.universal === false)
    .map(buildBudgetPieceFromItem)
}

export function formatBudgetPieceLine(piece: BudgetPiece): string {
  return formatBudgetReferenceLine(piece.referencia, piece.dimensions)
}
